export enum UserProfileEnum {
  Admin = 1,
  User = 2,
  SuperUser = 3,
  Visitor = 4,
  Monitor = 5
}
